import styled from 'styled-components';
import colors, { opacity } from 'styles/colors';
import { Card, Icon, Grid } from 'semantic-ui-react';
import RemoveIcon from 'assets/Remove';
import RentalDatesLinkIcon from 'assets/AgreementIcons/RentalDatesLink.svg';
import { StyledDatePicker } from 'components/DatePicker/styles';
import { fontWeight } from 'styles/common';

const StyledRemoveButton = styled.button`
  display: flex;
  align-items: center;
  padding: 3px;
  border: none;
  border-radius: 3px;

  :hover {
    background-color: ${colors.lightBackground};
  }
`;

export const RemoveButton = (props) => (
  <StyledRemoveButton {...props}>
    <RemoveIcon />
  </StyledRemoveButton>
);

const StyledRemoveAgreementButton = styled(StyledRemoveButton)`
  padding: 0;
`;

export const RemoveAgreementButton = (props) => (
  <StyledRemoveAgreementButton {...props}>
    <RemoveIcon />
  </StyledRemoveAgreementButton>
);

export const CardHeader = styled(Card.Header)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 56px;
  margin: 0 !important;
  border-bottom: ${({ $border }) => ($border ? `1px solid ${colors.fleetOffGray}` : 'none')};
`;

export const StyledCard = styled(Card)`
  width: 50% !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;

  .grid > .row:first-child {
    padding-top: 17px 0 6px 0;
  }

  && > .content {
    ${({ headerBorder = true }) => (!headerBorder ? 'border-top: 0;' : '')}
  }
`;

export const NotesCardContainer = styled.div`
  display: flex;
  margin: 1em 0;

  & > div:first-child {
    margin-right: 16px !important;
  }
`;

export const CustomIcon = styled(Icon)`
  display: flex !important;
  align-items: center !important;
  opacity: 1 !important;
  margin-left: 5px !important;
`;

export const StyledRentalLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 15px;
`;

export const StyledRentalLinks = styled.div`
  flex-basis: 50%;
  height: 2px;
  background: white url(${RentalDatesLinkIcon}) center repeat;
  margin-top: 16px;
`;

export const StyledRentalLinksWithDays = styled.div`
  flex-basis: 50%;
  height: 2px;
  background: white url(${RentalDatesLinkIcon}) center repeat;
  margin-top: 2px;
`;

export const StyledLinksCenterText = styled.div`
  border: solid 1px ${colors.fleetOffGray};
  box-shadow: 1px 2px 2px ${opacity(colors.black, 0.1)};
  border-radius: 4px;
  flex-shrink: 0;
  padding: 4px 10px;
  width: fit-content;
  height: 30px;
  text-align: center;
  font-weight: 600;
`;

export const DatePickerRow = styled(Grid.Row)`
  align-items: center !important;
  justify-content: space-between !important;
  flex-wrap: nowrap !important;
`;

export const DatePickerContainer = styled.div`
  display: flex;
  align-items: center;
  flex-basis: 340px;
  flex-shrink: 0;

  svg[width='41'] {
    margin-top: 12px;
  }

  & ${StyledDatePicker} {
    padding: 0 10px;
  }
`;

export const StyledDateInButton = styled.button`
  margin: 0 0 4px auto;
  font-size: 12px;
  font-weight: 600;
  color: ${colors.fleetBlue};
  border: none;
  padding: 0;
`;

export const DamageContent = styled.div`
  padding: 0 10px;
  width: 100%;
  height: fit-content;
`;

export const OdometerOutColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

export const OdometerOutContainer = styled.div`
  width: 100%;
`;

export const RequirementAsterisk = styled.div`
  color: ${colors.error};
  display: flex;
  align-items: flex-start;
  height: 100%;
`;

export const RequirementText = styled.div`
  color: ${colors.error};
  font-size: 12px;
  font-weight: ${fontWeight.regular};
  text-transform: capitalize;
`;

export const CCContainer = styled.div`
  display: flex;
  margin-bottom: 12px;
  gap: 2px;
`;
